import React from "react";
import "./customerinsights.scss";
import profileImg from "../../assest/page4.png";

const cards = [
	{
		title: "Revenue Snapshot",
		items: [
			"Total account value",
			"Renewal timelines",
			"Revenue concentration risk",
			"Expansion potential",
		],
	},
	{
		title: "Account Health Intelligence",
		items: [
			"Engagement indicators",
			"Consumption patterns",
			"Risk flags & early warning signals",
		],
	},
	{
		title: "Growth & Opportunity Tracking",
		items: [
			"Cross-sell pipeline",
			"Referral contribution",
			"Upsell conversion metrics",
		],
	},
	{
		title: "Executive Decision Support",
		items: [
			"Real-time dashboards",
			"Drill-down reporting",
			"Data-backed intervention capability",
		],
	},
	{
		title: "Ownership & Coverage Visibility",
		items: [
			"Account manager allocation",
			"Capacity load",
			"Role-based access & accountability",
		],
	},
];

const CustomerInsights = () => {
	return (
		<section id="customer360+" className="maincustomerInsights">
			<div className="subcustomerInsights">
				<div className="customerInsights">
					<div className="leftContent">
						<p className="description">
							Sciqus AMS delivers a comprehensive, real-time view of every
							customer relationship — consolidating segmentation, revenue
							exposure, consumption trends, renewal status, and growth
							opportunities into a single strategic interface.
						</p>
						<p className="description">
							This unified visibility empowers leadership teams to move from
							fragmented account tracking to structured revenue governance.
						</p>
						
						{/*<h1 className="main-heading">Customer Insights</h1>*/}
						
						<div className="cardsGrid">
							{/* Row 1 */}
							<div className="subcardsGrid">
								<h2>{cards[0].title}</h2>
								<ul>
									{cards[0].items.map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
							
							<div className="subcardsGrid">
								<h2>{cards[1].title}</h2>
								<ul>
									{cards[1].items.map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
							
							<div className="subcardsGridImage">
								<img src={profileImg} alt="support agent" />
							</div>
							
							{/* Row 2 */}
							<div className="subcardsGrid">
								<h2>{cards[2].title}</h2>
								<ul>
									{cards[2].items.map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
							
							<div className="subcardsGrid">
								<h2>{cards[3].title}</h2>
								<ul>
									{cards[3].items.map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
							
							<div className="subcardsGrid">
								<h2>{cards[4].title}</h2>
								<ul>
									{cards[4].items.map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CustomerInsights;